 
export const RequestSource = Object.freeze({
    Offerer: 0,
    Requester: 1,
});
